import React, { Component } from "react";
import { connect } from 'react-redux';
import { fromJS } from "immutable";
import { bindActionCreators } from 'redux'
import { toast } from "react-toastify";

import TextInputField from '../../infra/components/formInput/CustomTextInput' 
import ComboboxInput from '../../infra/components/formInput/ComboboxInput' 
import DatePickerInput from '../../infra/components/formInput/DatePickerInput'

import ActionAdd from '../../store/action/ReportBroadcast/Request'
import ActionGetAllUser from '../../store/action/Account/FetchAll'
import ActionGetAllClient from '../../store/action/Client/FetchAll'
import ActionGetAllDivision from '../../store/action/Division/FetchAll'
import ActionGetAllSender from '../../store/action/Sender/FetchAll'
import ActionGetAllTemplate from '../../store/action/TemplateHsm/Fetch'
import {IsEdit, IsCreate, IsView } from '../../store/constants'
import ActionGetAccessModuleIdAction from '../../store/action/AccessModule/FetchActionDispatch'
import {ClientId,DivisionId,SenderId,PrevilageId} from '../../helper/HelperAuth'
import moment, {now} from 'moment'

class Form extends Component{

  constructor(props){
    super(props);
    this.state ={
      form : fromJS({
        'request-id' : '',
        'request-date' : '',
        'client-id' : '',
        'division-id' : '',
        'sender-id' : '',
        'template-id' : '',
        'start-date' : '',
        'end-date' : '',
        'msisdn':'',
        'report-format':'',
        'message-add':'',
        'batchname':'',
      }),
      reportFormat : fromJS ([
            {
                'reportFormat-id' : 1,
                'reportFormat-name' : 'All'
            },
            {
              'reportFormat-id' : 2,
              'reportFormat-name' : 'Summary'
            },
            {
              'reportFormat-id' : 3,
              'reportFormat-name' : 'Detail'
            },
      ]),
      loadded: false,
      disabled: false,
      errors: fromJS({}),
      error: '',
      actionId:"",
      disableHead:true,
    };

    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleCancel = this.handleCancel.bind(this);
  }

  componentDidMount(){
      // this.props.actionGetAllUser();
      this.props.actionGetAllClient();
      this.props.actionGetAccessModuleIdAction('Report Push Notif');
    // this.props.actionGetAllDivision();
    // this.props.actionGetAllTemplate();
  }

  handleChange(field, value, label) {
    var formVal = this.state.form;
    formVal = formVal.set(field,value); 
    
    if(field === 'client-id'){
      this.props.actionGetAllDivision(value);
      this.props.actionGetAllSender(value);
      this.props.actionGetAllTemplate(value)
    }

    this.setState({ form:formVal })
  }

  async handleSubmit(dispatch) {
    const {form} = this.state;
    var isValid = true;
    const mandatoryField = fromJS(['client-id','start-date','end-date','report-format'])
    
    var newErrors = fromJS({});
    mandatoryField.map((field) => {
        if(form.get(field) === ''){
          isValid = false;
          newErrors = newErrors.set(field)
        }
    })

    this.setState({ errors: newErrors })

    if(!isValid){
      toast.error("Mandatory Field Cannot Empty!",toast.POSITION.TOP_RIGHT)
    }

    if(isValid){

      switch(this.props.actionType) {
        case IsCreate:
            await this.SubmitNewData();
          break;
        default:
          // code blocks
      }  

    }
  }

  async SubmitNewData(){
    const form = this.state.form;
    var data =  
        {'filter' : 
            {
                'spv-name' : form.get('spv-name'),
                'client-id' : form.get('client-id'),
                'division-id' : form.get('division-id'),
                // eslint-disable-next-line radix
                'sender-id' : form.get('sender-id')=='' ? "":parseInt(form.get('sender-id')),
                'start-date' : `${form.get('start-date')} 00:00:00`,
                'end-date' : `${form.get('end-date')} 23:59:59`,
                'msisdn': form.get('msisdn'),
                'template-id' : form.get('template-id'),
                'report-format' : form.get('report-format'),
                'batchname':form.get('batchname'),
                'message':form.get('message-add'),
                'privilege-id' : PrevilageId,
            }
        };
    // console.log(data, 'data request');
    //debugger;
    var response = await this.props.actionAdd(data);
    //debugger;
    if(response.ok){
      toast.success('Save Success!', toast.POSITION.TOP_RIGHT);
      this.props.handleCancelForm(true); 
    }else{
      //toast.error('Save Failed', toast.POSITION.TOP_RIGHT);
    }
  }
  
  handleCancel(){
    this.props.handleCancelForm(false);  
  }

  componentWillMount(){
    if(this.props.item != null || this.props.item !== undefined){
      if((this.props.actionType === IsCreate) && !this.state.loadded){
          var varActionId = "";
          var dataAkses =null;

          setTimeout(() => {
              dataAkses = this.props.accessmoduleaction;
              if(dataAkses){
                  varActionId=dataAkses.get("action-id");
                  this.setState({actionId:varActionId});
                  if(varActionId==5){
                      this.props.actionGetAllDivision(ClientId);
                      this.props.actionGetAllTemplate(ClientId,SenderId,varActionId)
                      this.props.actionGetAllSender(ClientId);
                      this.setState({
                          form:  fromJS({
                              'client-id' : ClientId,
                              'division-id' : DivisionId,
                              'sender-id' : SenderId,
                              'template-id' : '',
                              'start-date' : '',
                              'end-date' : '',
                              'msisdn':'',
                              'report-format':'',
                              'message-add':'',
                              'batchname':'',

                          }),
                          loadded: true,
                          disableHead: true
                      })
                  }else{
                      this.setState({
                          form:  fromJS({
                              'client-id' : '',
                              'division-id' : '',
                              'sender-id' : '',
                              'template-id' : '',
                              'start-date' : '',
                              'end-date' : '',
                              'msisdn':'',
                              'report-format':'',
                              'message-add':'',
                              'batchname':'',
                          }),
                          loadded: true,
                          disabled: (this.props.actionType === IsView),
                          disableHead: false
                      })
                  }
              }
          }, 8000);
      }
    }
  }

  render(){
    const { form, errors,reportFormat, disabled } = this.state;
    return (
      <div className="card no-margin-bottom">
      <div className="body">
        <div className="row no-margin-bottom">
              <span className="col-sm-2">Client *</span>
              <div className="col-sm-10">
                  <ComboboxInput
                    field='client-id'
                    value={form.get('client-id')}
                    options={fromJS({
                        'source': this.props.clientall,
                        'value': 'client-id',
                        'label': 'client-name'
                    }) }
                    onChange={(field, value, label) => this.handleChange(field,value,label)}
                    placeholder="Client"
                    disabled={this.state.disableHead}
                    hasError={errors.has('client-id')}
                />  
              </div>
          </div>

          <div className="row no-margin-bottom">
              <span className="col-sm-2">Division</span>
              <div className="col-sm-10">
                  <ComboboxInput
                    field='division-id'
                    value={form.get('division-id')}
                    options={fromJS({
                        'source': this.props.divisionall,
                        'value': 'division-id',
                        'label': 'division-name'
                    }) }
                    onChange={(field, value, label) => this.handleChange(field,value,label)}
                    placeholder="Division"
                    disabled={this.state.disableHead}
                    hasError={errors.has('division-id')}
                  />
              </div>
          </div>

          <div className="row no-margin-bottom">
              <span className="col-sm-2">Sender *</span>
              <div className="col-sm-10">
                <ComboboxInput
                    field='sender-id'
                    value={form.get('sender-id')}
                    options={fromJS({
                        'source': this.props.senderall,
                        'value': 'sender-id',
                        'label': 'sender-name'
                    }) }
                    onChange={(field, value, label) => this.handleChange(field,value,label)}
                    placeholder="Sender"
                    disabled={this.state.disableHead}
                    hasError={errors.has('sender-id')}
                  />
              </div>
          </div>
          <div className="row no-margin-bottom">
              <span className="col-sm-2">Report Format *</span>
              <div className="col-sm-10">
                  <ComboboxInput
                      field='report-format'
                      value={form.get('report-format')}
                      options={fromJS({
                          'source': reportFormat,
                          'value': 'reportFormat-id',
                          'label': 'reportFormat-name'
                      }) }
                      onChange={(field, value, label) => this.handleChange(field,value,label)}
                      placeholder="Report Format"
                      disabled={ disabled }
                      hasError={errors.has('report-format')}
                  />
              </div>
          </div>


          <div className="row no-margin-bottom">
              <span className="col-sm-2">Start Date *</span>
              <div className="col-sm-10">
                <DatePickerInput
                  dateFormat="yyyy-MM-dd"
                  convertvalue
                  field="start-date"
                  value={ form.get('start-date') }
                  onChange={(field, date) => this.handleChange(field, date)}
                  // minDate={new Date("01-01-2021")}
                  minDate={new Date(moment().subtract(3, "month").format("YYYY-MM-DD "))}
                  maxDate={new Date()}
                  // minDate={addMonths(new Date(), 3)}
                />
              </div>
          </div>

          <div className="row no-margin-bottom">
              <span className="col-sm-2">End Date *</span>
              <div className="col-sm-10">
                <DatePickerInput
                  convertvalue
                  dateFormat="yyyy-MM-dd"
                  field="end-date"
                  value={ form.get('end-date') }
                  onChange={(field, date) => this.handleChange(field, date)}
                  minDate={new Date(moment().subtract(3, "month").format("YYYY-MM-DD "))}
                  maxDate={new Date()}
                />
              </div>
          </div>
          <div className="row no-margin-bottom">
            <span className="col-sm-2">Template</span>
            <div className="col-sm-10">
              <ComboboxInput
                field='template-id'
                value={form.get('template-id')}
                options={fromJS({
                  'source': this.props.templateall,
                  'value': 'template-id',
                  'label': 'template-name'
                })}
                onChange={(field, value, label) => this.handleChange(field, value, label)}
                placeholder="template"
                disabled={this.state.disabled}
                hasError={errors.has('template-id')}
              />
            </div>
          </div>
          <div className="row no-margin-bottom">
              <span className="col-sm-2">MSISDN</span>
              <div className="col-sm-10">
                <TextInputField className="form-control"
                  field={'msisdn'}
                  value={ form.get('msisdn')}
                  onChange={(field, value) => this.handleChange(field,value)}
                  placeholder="msisdn"
                  disabled={ disabled }
                  hasError={errors.has('msisdn')}
                />
              </div>
          </div>
          <div className="row no-margin-bottom">
              <span className="col-sm-2">Batchname</span>
              <div className="col-sm-10">
                  <TextInputField className="form-control"
                                  field={'batchname'}
                                  value={ form.get('batchname')}
                                  onChange={(field, value) => this.handleChange(field,value)}
                                  placeholder="Batchname"
                                  disabled={ disabled }
                                  hasError={errors.has('batchname')}
                  />
              </div>
          </div>
          <div className="row no-margin-bottom">
              <span className="col-sm-2">Message</span>
              <div className="col-sm-10">
                  <TextInputField className="form-control"
                                  field={'message-add'}
                                  value={ form.get('message-add')}
                                  onChange={(field, value) => this.handleChange(field,value)}
                                  placeholder="Message"
                                  disabled={ disabled }
                                  hasError={errors.has('message-add')}
                  />
              </div>
          </div>

          {this.renderFormName(form, errors)} 

          <div className="row no-margin-bottom">
            <span className="col-sm-2"></span>
            <div className="col-sm-10">
            <button type="button"
                  className="btn btn-wide btn-danger"
                  value="Cancel"
                  onClick={ this.handleCancel }>
                    Cancel
              </button>
              <button type="button" 
                  className="btn btn-wide btn-success"
                  onClick={ this.handleSubmit }>
                    Submit
              </button>
            </div>
          </div>
        </div>
        </div>
    );
  }

  renderFormName(form, errors){
    if(this.props.actionType === IsEdit){
      return(
        <div className="row no-margin-bottom">
              <span className="col-sm-2">Name</span>
              <div className="col-sm-10">
                  <TextInputField className="form-control"
                      field={'spv-name'}
                      value={ form.get('spv-name')}
                      onChange={(field, value) => this.handleChange(field,value)}
                      placeholder="name"
                      hasError={errors.has('spv-name')}
                  />
              </div>
        </div>
      )
    }
  }
  

}


export default connect(
  (state) => {
      return {
          Users: state.user.users,
          userall: state.user.userall,
          clientall: state.user.clientall,
          divisionall: state.user.divisionall,
          senderall: state.user.senders,
          templateall: state.user.templateall,
          accessmoduleaction: state.user.accessmoduleaction,
      }
  },
  dispatch => bindActionCreators({
      actionAdd: ActionAdd,
      actionGetAllUser: ActionGetAllUser,
      actionGetAllClient: ActionGetAllClient,
      actionGetAllDivision: ActionGetAllDivision,
      actionGetAllSender: ActionGetAllSender,
      actionGetAllTemplate: ActionGetAllTemplate,
      actionGetAccessModuleIdAction:ActionGetAccessModuleIdAction,
  }, dispatch),
)(Form);